import React, { useEffect, useRef } from "react";
import { getRpaTransportUrl } from "./RpaUrlHelper";
import { getReadableTextColor } from "../../../app/formatters/ColorFormatter";
import { useMediaQuery } from "react-responsive";
import moment from "moment";

/** @typedef {import('../controllers/RpaController.js').FilterObj } FilterObj */

/**
 * @typedef {object} RpaPlanningSideSearchParams
 * @property {FilterObj} filter - Objet de filtre
 * @property {'front'|'back'} view - Vue (back ou front)
 * @property {boolean} transportAndParkingOption - Mode premium activé ou pas
 * @property {?number} columnWidth - Largeur des colonnes
 * @property {function(string, object):void} onDateChange - Fonction de changement de date
 * @property {function(number, any):void} onChangeOnRpaResource - Fonction de changement de ressource
 * @property {function(any):void} onColumnWidthChange - Fonction de changement de la largeur des colonnes
 * @property {function(any):void} onChangeOnDisplayMode - Fonction de changement du mode d'affichage
 * @property {'week'|'day'} displayMode - Mode d'affichage (day ou week)
 * @property {?import('../../../app/models/UserModel.js').UserItem} connectedUser - Utilisateur connecté
 */

/**
 * @param {RpaPlanningSideSearchParams} props
 */
export default function RpaPlanningSideSearch({ filter, view, transportAndParkingOption, columnWidth, onDateChange, onChangeOnRpaResource, onColumnWidthChange, onChangeOnDisplayMode, displayMode, connectedUser }) {
  var inputRef = useRef(),
    datePickerRef = useRef(),
    onDateChangeRef = useRef(onDateChange),
    isMobile = useMediaQuery({ query: "(min-width: 320px) and (max-width: 935px)" });

  useEffect(() => {
    /**
     * @param {any} event
     */
    var handleChangeDate = event => {
      onDateChangeRef.current(moment(event.detail.date).format("DD/MM/YYYY"), inputRef);
    };

    if (inputRef.current) {
      if (datePickerRef.current) {
        /** @type {any}*/ (datePickerRef.current).destroy();
      }

      var options = {
        language: "fr",
        autohide: true,
        clearBtn: false,
        todayBtn: false,
        todayHighlight: true,
        todayBtnMode: 1,
        format: "dd/mm/yyyy",
        container: inputRef.current
      };

      // @ts-ignore
      datePickerRef.current = new Datepicker(inputRef.current, options);
      /** @type {any}*/ (datePickerRef.current).setDate(filter.dayDateStr);
      /** @type {HTMLInputElement}*/ (inputRef.current).addEventListener("changeDate", handleChangeDate);
    }

    return () => {
      if (inputRef.current) {
        /** @type {HTMLInputElement}*/ (inputRef.current).removeEventListener("changeDate", handleChangeDate);
      }
    };
  }, [filter.dayDate, inputRef.current]);

  useEffect(() => {
    onDateChangeRef.current = onDateChange;
  }, [onDateChange]);

  return !isMobile ? (
    <div className="resaplan__search resaplan__search--vertical">
      <div className="resaplan__search-content">
        <div className="flexline flexline--align-hz no-mobile">
          <div
            // @ts-ignore
            ref={inputRef}></div>
        </div>
        <div className="space--8"></div>
        <div className="flexline flexline--margin flexline--align-vz flexline--spaced">
          <button data-loader="true" onClick={() => onDateChange(moment(filter.dayDate).subtract(1, "day").format("DD/M/YYYY"), inputRef)} className="btn btn--small btn--no-label">
            <span className="material-icons">chevron_left</span>
          </button>
          <button data-loader="true" className="btn btn--full" onClick={() => onDateChange(moment().format("DD/M/YYYY"), inputRef)}>
            Aujourd'hui
          </button>
          <button data-loader="true" onClick={() => onDateChange(moment(filter.dayDate).add(1, "day").format("DD/M/YYYY"), inputRef)} className="btn btn--small btn--no-label">
            <span className="material-icons">chevron_right</span>
          </button>
        </div>

        {view === "back" && transportAndParkingOption ? (
          <div>
            <p className="resaplan__search-title">Planning transports</p>
            <a href={getRpaTransportUrl(filter.dayDateStr)} data-tooltip="Récapitulatif des transports" className="btn btn--main-color btn--full">
              Transports
            </a>
          </div>
        ) : (
          ""
        )}
        {view === "back" ? (
          <>
            <p className="resaplan__search-title">Affichage</p>
            <select className="input-group__input" onChange={onChangeOnDisplayMode} value={displayMode}>
              <option value="day">Journée</option>
              <option value="threedays">Trois jours</option>
              <option value="week">Semaine</option>
              <option value="threeweeks">Trois semaines</option>
              <option value="month">Mois</option>
            </select>

            {connectedUser && connectedUser.right <= 1 && (displayMode === "day" || displayMode === "week") ? (
              <>
                <div className="space--8"></div>
                <a href={`/rpa-schedule-grid/_duplic/${moment(filter.dayDate).format("DD-MM-YYYY")}/${displayMode}?forcedreturnurl=${encodeURIComponent(`/rpa/_index?dayDateStr=${filter.dayDateStr}&sidebarreduce=true`)}`} className="btn btn--main-color btn--full">
                  Dupliquer cette période
                </a>
              </>
            ) : (
              ""
            )}

            <p className="resaplan__search-title">Liste des resources</p>
            <div className="resaplan__search-filters">
              {filter.rpaResources.map((rpaResourceInFilter, index) => (
                <label htmlFor={`rpaResourceFilter${index}`} className="resaplan__search-line-filter" key={index} style={{ backgroundColor: rpaResourceInFilter.color, color: getReadableTextColor(rpaResourceInFilter.color) }}>
                  <input id={`rpaResourceFilter${index}`} aria-label="Resource" type="checkbox" onChange={e => onChangeOnRpaResource(rpaResourceInFilter.rpaResourceId, e)} checked={rpaResourceInFilter.checked} />
                  {rpaResourceInFilter.name}
                </label>
              ))}
            </div>
            <p className="resaplan__search-title">Colonnes</p>
            <input style={{ width: "100%" }} aria-label="Largeur des colonnes" type="range" min="50" max="500" value={columnWidth || ""} onChange={e => onColumnWidthChange(e)} />
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  ) : (
    <div></div>
  );
}
